<template>
  <div class="not-found-main" :style="{ backgroundColor: `#${backgroundColor}` }">
    <div class="not-found-body">
      <img src="http://121.121.40.185:88/logo/DSM.GIF">
      <div style="margin: 3px 0 5px 0">
        {{ fullURL.split('%20').join(' ') }} <br />
        could not be found
      </div>
      <button @click="backHomeClicked()">Back To Home</button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data: function() {
    return {
      userParam: '',
    }
  },
  props: {
    fullURL: { type: String, default: '' },
    backgroundColor: { type: String, default: 'E0ECF8' },
  },
  methods: {
    backHomeClicked: function() {
      // this.$router.go(-1);
      this.$router.push(`/Home/${this.userParam}`);
    },
    escapePress: function(e) {
      if (e.key == 'Escape') {
        this.backHomeClicked();
      }
    }
  },
  async mounted() {
    this.userParam = this.$route.params['pathMatch'].split('/')[2];
    this.fullURL = window.location.href;
    window.addEventListener('keyup', this.escapePress);

    var userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');
    if (userOptionsData[0].SettingsValue) {
      var userOptionsObj = JSON.parse(userOptionsData.data[0].SettingsValue);

      this.backgroundColor = userOptionsObj.BackgroundColor ? userOptionsObj.BackgroundColor : 'E0ECF8';
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found-main {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  text-align: center;

  > .not-found-body {
    background-color: white;
    padding: 25px;
    border-radius: 5px;
    position: relative;
    top: 20%;

    > img {
      width: 100%;
      min-width: 100px;
      max-width: 250px;
    }
  }
}
</style>